import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';
import { PatientTemplateCustomOrderingDoctorChangeModalStore } from "../stores";
import { PatientTemplateCustomOrderingDoctorChangeModalTemplate } from "themes/application/niko-patient/components";

@setCurrentView((rootStore, componentProps) => new PatientTemplateCustomOrderingDoctorChangeModalStore(rootStore, componentProps), 'patientTemplateCustomOrderingDoctorChangeModalStore')
@observer
class PatientTemplateCustomOrderingDoctorChangeModal extends React.Component {
	render() {
		return <PatientTemplateCustomOrderingDoctorChangeModalTemplate {...this.props} />;
	}
}

export default PatientTemplateCustomOrderingDoctorChangeModal;